import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { MiniMapState } from '../../social-mini-map/mini-map-state';
import { SocialMiniMapComponent } from '../../social-mini-map/social-mini-map.component';

@Component({
  selector: 'app-presentation-shell',
  templateUrl: './presentation-shell.component.html',
  styleUrls: ['./presentation-shell.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PresentationShellComponent {
  public readonly absolute = input(true);
  public readonly isMobile = input(false);

  public constructor() {
    const socialMiniMap = SocialMiniMapComponent.getInstance();
    if (socialMiniMap) {
      socialMiniMap.toggleMap(MiniMapState.CLOSED);
    }
  }
}
